import type { BaseTranslation } from '../../i18n-types';

// eslint-disable-next-line @typescript-eslint/naming-convention
const cs_zod = {
	requiredField: 'Toto pole je povinné',
	dataNoAvailableWait: 'Data se ještě nenačetli, zkuste to za chvíli',
	maxStringLength: 'Maximální délka textu je {max: number} znaků',
	alphabetError: 'Povoleny jsou pouze písmena, mezera nebo pomlčka',
	noSlashError: 'Číslo zadávejte bez lomítka',
	numberError: 'Povolena jsou pouze čísla',
	phoneNumberExactLength: 'Číslo musí mít {length: number} číslic',
	phoneNumberLengthRange: 'Číslo musí mít {min: number}–{max: number} číslic',
	emailError: 'Pole musí být validní email',
	atLeastOneFieldMustBeFilledIn: 'Musí být vyplněno alespoň jedno pole',
	birthNumberLength:
		'Rodné číslo musí mít {minBirthNumberLength: number} nebo {maxBirthNumberLength: number} znaků',
	insuranceNumberLength:
		'Číslo pojištěnce musí mít maximálně {maxInsuranceNumberLength: number} znaků',
	negativeAmountNotAllowed: 'Částka nesmí být záporná',
	amountFromHasToBeLessThanAmountTo: 'Částka od musí být menší než částka do',
	dateToMustBeBeforeDateFrom: 'Datum musí být větší nebo rovno Datumu od',
	dateMustBeTodayAtLatest: 'Datum musí být nejpozději dnešní',
	dateCantBeEarlierThanBankInceptionDate:
		'Datum nemůže být dříve než datum spuštění banky (1. 11. 2023)',
	dateMustBeAfterOrEqualMin:
		'Datum musí být větší nebo rovno minimálnímu povolenému datu',
	dateMustBeBeforeOrEqualToday: 'Datum musí být menší nebo rovno dnešnímu dni',
	dateMustBeAfterOrEqualToday: 'Datum musí být dnešní nebo pozdější',
	changeNationalIdentifierDialog: {
		birthNumberLength:
			'Rodné číslo musí mít {minBirthNumberLength: number} nebo {maxBirthNumberLength: number} znaků',
		birthNumberRemainder:
			'Rodné číslo musí být dělitelné {number: number} bez zbytku',
		birthNumberRegex: 'Zadávejte pouze čísla bez lomítka',
		birthNumberInvalid: 'Neplatné rodné číslo',
		insuranceNumberLength:
			'Číslo pojištěnce musí mít maximálně {maxInsuranceNumberLength: number} znaků',
		insuranceNumberRegex: 'Povolené znaky jsou číslice, malá a velká písmena',
		unspecifiedNumberLength:
			'Číslo musí mít maximálně {maxUnspecifiedNumberLength: number} znaků',
		unspecifiedNumberRegex: 'Povolené znaky jsou číslice, malá a velká písmena',
	},
	applicationsActivations: {
		wrongActivationState:
			'Stav je možné zvolit pouze pro typ aktivace "Verifikace dokladem" nebo "QR kód u poradce"',
		userSubFilterOnlyWithBankId:
			'Identifikátor je možné zvolit pouze pro typ aktivace "Bank iD onboarding" nebo "Bank iD aktivace"',
	},
	reportForStateInstitutions: {
		fromAndToDatesHaveToBePicked: 'Zadejte datum od i do',
		atLeastOneAccountMustBeSelected: 'Vyberte alespoň jeden účet',
		atLeastOneScopeOptionShouldBeSelected:
			'Vyberte alespoň jednu možnost ze sekce Klient nebo Produkty',
	},
	advisorIdLength:
		'ID poradce musí mít min. {minLength: number} a max. {maxLength: number} číslic',
	invalidClientPid: 'Nesprávný PID klienta.',
	invalidCharacters: 'Pole obsahuje nepovolené znaky',
	documentNumberLength:
		'Doklad musí mít min. {minLength: number} a max. {maxLength: number} číslic',
	inputMinLength:
		'Pole musí mít minimálně {minLength: number} {characters: string}',
} satisfies BaseTranslation;

export default cs_zod;
